import Lottie from 'lottie-react';
import { useState, useEffect } from 'react';
import { Button } from '@/shared/components/Buttons';
import { ButtonVariant } from '@/shared/components/Buttons/types';

interface FacilityListErrorBlockProps {
  onRetry: () => void;
}

const FacilityListErrorBlock = ({ onRetry }: FacilityListErrorBlockProps) => {
  const [animationData, setAnimationData] = useState<object | null>(null);

  useEffect(() => {
    import('../../../assets/lottie/somethingWetWrong.json')
      .then((module) => setAnimationData(module.default as object))
      .catch(() => {});
  }, []);

  return (
    <div className="flex flex-col items-center gap-5 justify-center min-h-[300px]">
      {animationData && (
        <Lottie
          animationData={animationData}
          loop={false}
          style={{ width: '30%', height: '30%' }}
        />
      )}
      <div className="flex flex-col items-center justify-center gap-1">
        <h1
          className="text-bodyLarge font-medium text-center"
          style={{ color: '#474A4C' }}
        >
          Coś poszło nie tak...
        </h1>
        <p className="text-bodyLarge text-on-surface-variant text-center">
          Nie udało się załadować listy placówek.
        </p>
      </div>
      <Button
        label="Spróbuj ponownie"
        className="hover:cursor-pointer"
        variant={ButtonVariant.Primary}
        size="Small"
        onClick={onRetry}
      />
    </div>
  );
};

export default FacilityListErrorBlock;
